<template>
  <v-list class="notificationList">
    <NotificationCard
      v-for="notif in notifications"
      :key="notif.id"
      :notification="notif"
    />
  </v-list>
</template>
<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import NotificationCard from './NotificationCard';
import { types as notificationsTypes } from '../../store/notifications';

export default {
  name: 'Notifications',
  components: {
    NotificationCard,
  },
  computed: {
    ...mapGetters({
      notifications: notificationsTypes.getters.notifications,
    }),
  },
  created() {
    this.markAllDisplayed();
  },
  methods: {
    ...mapActions({
      markAllDisplayed: notificationsTypes.actions.markAllDisplayed,
    }),
    notificationTimestamp(timestamp) {
      return moment(timestamp).fromNow();
    },
  },
};
</script>
<style scoped>
.notificationList {
  max-height: calc(100vh - 68px);
  overflow: auto;
}
</style>
